<template>
  <div class="clw">
    <form  @submit.prevent="submit">
    <div class="clct">
      <h1>Merci de saisir votre short code</h1>
      <input type="text" v-model="code" />
    </div>
    <button>Valider</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: undefined,
    };
  },
  methods : {
    submit() {
        this.code = this.code.trim();
        this.code = this.code.replace(/caractères_à_supprimer/g, '');
        this.$router.push("/client/" + this.code);
    }

  }
};
</script>

<style scoped>
.clw {
  color: white;
  position: absolute;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 99%;
  width: 99%;
  text-align: center;
}

.clw h1 {
  
    text-align: center;
    width: 100%;
    
}

.clw input {
  font-size: 20px;
  color: black;
  padding: 10px;
  width: 100%;
  border-radius: 25px;
}

button {
    margin-top: 20px;
}


</style>
